<ng-template #MilitaryDisable>
    <div class="modal-header">
        <h5 class="modal-title">Military Information</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body viewMilitaryInfoForm">
        <h6 class="sectionTitle mb-2">Military Information</h6>
        <div class="card p-3">
        <div class="form-row mx-0 d-flex">
            <label for="">Service Member Name</label>
            <span class="mx-2">:</span>
            <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.ServiceMemberName:''}}</p>
        </div>
            <div class="form-row mx-0 d-flex">
                <label for="">DOD #</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.DODNumber:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Military Deployment Start Date</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military ? (this.customerInfoDetails.MilitaryDeploymentDate | date:'MM/dd/yyyy') : ''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Military Id Exp Date</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military ? (this.customerInfoDetails.MilitaryIdExpDate | date:'MM/dd/yyyy') : ''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Rank</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.Rank:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Military Unit Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.MilitaryUnitName:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Military Branch</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.MilitaryBranch:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Military Base</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.MilitaryBase:''}}</p>
            </div>
        </div>

        <h6 class="sectionTitle my-3">Commanding Officer Information </h6>
        <div class="card p-3">
            <div class="form-row mx-0 d-flex">
                <label for="">First Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COIFirstName:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Last Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COILastName:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Rank</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COIRank:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Address</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COIAddress:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">City</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COICity:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">State / Province</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.stateSelectedMilitary :''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Zip / Postal Code</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COIZip:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Country</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.countrySelectedMilitary:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Cell Phone</label>
                <span class="mx-2">:</span>
                <p>{{this.COICellPhoneCountryIdDialCode}}{{this.customerInfoDetails.COICellPhone | phone:1}}
                </p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Email</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails?.Military?this.customerInfoDetails.COIEmail:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Fax</label>
                <span class="mx-2">:</span>
                <p>{{this.COIFaxIdDialCode}}{{this.customerInfoDetails.COIFax | phone:1}}</p>
            </div>
        </div>

    </div>
    <!-- // End View Military Info Modal -->
</ng-template>

<ng-template #BusinessDisable>
    <div class="modal-header">
        <h5 class="modal-title">Business Account</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body viewbusinessAcInfo">
        <div class="card p-3">
            <div class="form-row mx-0 d-flex">
                <label for="">Company Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount?this.customerInfoDetails.CompanyName:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Contact Person First Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount?this.customerInfoDetails.FirstName:''}}</p>
            </div>

            <div class="form-row mx-0 d-flex">
                <label for="">Middle Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount?this.customerInfoDetails.MiddleName:''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Last Name</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount?this.customerInfoDetails.LastName:''}}</p>
            </div>

            <div class="form-row mx-0 d-flex">
                <label for="">Address</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount ? this.customerInfoDetails.CompanyAddress : ''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">City</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount ? this.customerInfoDetails.CompanyCity : ''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">State / Province</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount ? this.stateDetailsBusiness : ""}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Zip / Postal Code</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount ? this.customerInfoDetails.CompanyZip : ''}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Country</label>
                <span class="mx-2">:</span>
                <p>{{this.customerInfoDetails.BusinessAccount ? this.countryDetailsBusiness : ""}}</p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Phone</label>
                <span class="mx-2">:</span>
                <p>{{this.CompanyPhoneCountryIdDialCode}}{{this.customerInfoDetails.CompanyPhone | phone:1}}
                </p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Fax</label>
                <span class="mx-2">:</span>
                <p>{{this.CompanyFaxCountryIdDialCode}}{{this.customerInfoDetails.CompanyFax | phone:1}}
                </p>
            </div>
            <div class="form-row mx-0 d-flex">
                <label for="">Email</label>
                <span class="mx-2">:</span>
                <p>{{EmailId?EmailId : this.customerInfoDetails.CompanyEmail? this.customerInfoDetails.CompanyEmail : ""}}</p>
            </div>

        </div>
    </div>

</ng-template>